<template>
  <span v-if="count > 0" class="notification-badge">{{ count }}</span>
</template>

<script setup lang="ts">
defineProps<{ count: number }>()
</script>

<style scoped>
.notification-badge {
  display: inline-block;
  min-width: 20px;
  padding: 2px 6px;
  background: #e53935;
  color: #fff;
  border-radius: 12px;
  font-size: 0.85em;
  text-align: center;
  vertical-align: top;
  margin-left: 4px;
}
</style>
